'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

ControllerExtensions=function(){
function ControllerExtensions(controller){_classCallCheck(this,ControllerExtensions);
this._controller=controller;
}ControllerExtensions.prototype.

getMultiViewConfigurationFor=function getMultiViewConfigurationFor(controllerPropertiesToBindToSubViews,multiViewConfigurations){
const sharedSubViewBindings=_.transform(
controllerPropertiesToBindToSubViews,
function(result,value,key){return result[_.kebabCase(value)]=`controller.${value}`});


return multiViewConfigurations.map(function(config){return Object.assign({bindings:sharedSubViewBindings},config)});
};ControllerExtensions.

extend=function extend(controller){
return new ControllerExtensions(controller);
};return ControllerExtensions}();


module.exports=ControllerExtensions.extend;
//# sourceMappingURL=controllerExtensions.js.map
